<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="talepTur">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Talep Tür' : 'Talep Tür Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()" [ngClass]="{'disabled':talepTur.isim.length===0}">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Talep Türü Adı</div>
                <input type="text" class="form-control" placeholder="Şube adı" [(ngModel)]="talepTur.isim">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
